import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_SelectGroupV2 = _resolveComponent("SelectGroupV2")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SelectGroupV2, {
      searchCustomerNameMode: false,
      dataSearch: _ctx.allCountry,
      onSearch: _ctx.onFilterCountry,
      code: _ctx.code,
      "onUpdate:code": _ctx.onSelectCode,
      customer: _ctx.selectedCustomer,
      "onUpdate:customer": [
        _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCustomer = $event)),
        _ctx.onSelect
      ],
      phone: _ctx.phone,
      onSetValue: _ctx.setValueCountry,
      onPasteText: _ctx.pasteText,
      error: !!_ctx.error,
      maxLength: _ctx.maxLengthPhoneNumber(_ctx.phone),
      format: _ctx.formatNumber,
      onChange: _ctx.onChange,
      onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('focus'))),
      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('blur'))),
      isEditItem: _ctx.isEditItem,
      onEditItem: _ctx.onEditOption,
      isLoading: _ctx.isLoading,
      disabled: _ctx.disabled,
      options: _ctx.options,
      disabledUserDropdown: _ctx.disabledUserDropdown,
      countryCodeButtonId: _ctx.countryCodeButtonId,
      phoneNumberFieldId: _ctx.phoneNumberFieldId,
      keyValue: "customerPhoneNumber",
      keyName: "customerPhoneNumber",
      placeholder: 
        _ctx.$t(
          _ctx.isBookingV4
            ? 'bookingV4.sender.phone.placeholder'
            : 'bookingShipment.placeholder.shipperPhoneNumber'
        )
      ,
      errorMessage: 
        _ctx.isReverseJourney ? '' : _ctx.$t('bookingV3.errorCustomerNotFound')
      ,
      isShowErrorMessage: _ctx.isReverseJourney ? false : true,
      isShowIconEmpty: _ctx.isReverseJourney ? true : false,
      useInfiniteScroll: _ctx.useInfiniteScroll,
      onScrolled: _ctx.onScroll
    }, _createSlots({
      option: _withCtx(({ item }) => [
        _createVNode("div", {
          class: "flex-grow truncate pr-1",
          innerHTML: 
            _ctx.highlightSearch(
              `+${item?.customerPhoneNumber} (${item?.customerName})`
            )
          
        }, null, 8, ["innerHTML"])
      ]),
      _: 2
    }, [
      (_ctx.error)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.error)) + " ", 1),
                (_ctx.error.match(/valid/gi) && !_ctx.accountIsForeign)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltipCheckGuide($event))),
                      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleTooltipCheckGuide($event))),
                      class: "underline font-semibold cursor-pointer"
                    }, _toDisplayString(_ctx.$t("bookingV3.senderPhone.error.checkGuide")), 33))
                  : _createCommentVNode("", true),
                _createVNode(_component_OverlayPanel, {
                  ref: "check-guide",
                  appendTo: "body",
                  style: {"width":"332px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode("span", {
                      class: "text-xs text-black-lp-300 font-montserrat",
                      innerHTML: _ctx.$t('bookingV3.senderPhone.error.checkGuideTooltip')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 1
                }, 512)
              ])
            ])
          }
        : undefined
    ]), 1032, ["dataSearch", "onSearch", "code", "onUpdate:code", "customer", "onUpdate:customer", "phone", "onSetValue", "onPasteText", "error", "maxLength", "format", "onChange", "isEditItem", "onEditItem", "isLoading", "disabled", "options", "disabledUserDropdown", "countryCodeButtonId", "phoneNumberFieldId", "placeholder", "errorMessage", "isShowErrorMessage", "isShowIconEmpty", "useInfiniteScroll", "onScrolled"]),
    (_ctx.validPhone)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["absolute transform right-4 top-1/2 -translate-y-1/2 flex items-center gap-x-1 text-green-lp-400 pl-1", {
        'bg-gray-lp-1500': _ctx.disabled,
        'bg-white': !_ctx.disabled
      }]
        }, [
          _createVNode(_component_Icons, {
            name: "check-circle",
            class: "w-4"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.isBookingV4 ? "bookingV4.valid" : "bookingV3.senderPhone.valid")), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}